// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"7df398c9","376":"f005f4c1","810":"39aaaf23"}[chunkId] + ".chunk.js";
};